import { useContext } from 'react';
import ContextStates from '../context/ContextStates';
import Layout from '../components/Layout';
import FEditPresupuesto from '../components/admin/fEditPresupuesto';


const Presupuesto = () => {

    return (
        <Layout
            pagina={"Mi compra"}
        >
            <div className='w-full pt-20 pb-20'>
                <FEditPresupuesto />
            </div>
        </Layout>
    )
}

export default Presupuesto